export const buildCSVString = (headers: string[], rows: Record<string, unknown>[]): string => {
	const escape = (v: unknown) => `"${String(v ?? '').replace(/"/g, '""')}"`;
	return [
		headers.join(','),
		...rows.map((r) => headers.map((h) => escape(r[h])).join(',')),
	].join('\n');
};
